import { NavigationProvider } from '@web/navigation/NavigationProvider';
import { NavigateAction } from '@web/navigation/navigationProvider.types';

import AnnualPlanAnnouncement from './AnnualPlanAnnouncement';

const AnnualPlanAnnouncementAngular = ({ currentUser, stateService, saveClientFlags }) => {
  const navigate: NavigateAction = (path, params) => {
    stateService.go(path, params);
  };

  return (
    <NavigationProvider navigate={navigate}>
      <AnnualPlanAnnouncement currentUser={currentUser} saveClientFlags={saveClientFlags} />
    </NavigationProvider>
  );
};

export default {
  ReactComponent: AnnualPlanAnnouncementAngular,
  bindings: {
    currentUser: '<',
    stateService: '<',
    saveClientFlags: '<',
  },
};
